<script>import { onMount } from 'svelte';
import { currentUser } from './utils/stores.js';
import { NotificationDisplay } from '@shopboxai/sb-portal-components';
import Admin from './views/Admin.svelte';
export let user;
let mounted = false;
onMount(() => {
    currentUser.set(user);
    mounted = true;
});
</script>

{#if mounted}
	<main>
		<h1>Admin</h1>
		<Admin />
		<NotificationDisplay />
	</main>
{/if}

<style>
	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
	}
	h1 {
		font-family: 'Chivo', sans-serif;
		font-weight: 900;
		font-size: 34px;
		line-height: 40px;
		letter-spacing: 0.5px;
		color: #05126d;
		flex: none;
		order: 1;
		flex-grow: 0;
	}
	main {
		width: 100%;
		position: relative;
		max-width: 1200px;
		margin: 0 auto;
	}
</style>
